import { render, staticRenderFns } from "./ReportFormSimple.vue?vue&type=template&id=6e9ceecd"
import script from "./ReportFormSimple.vue?vue&type=script&lang=js"
export * from "./ReportFormSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports